import {useLang} from '@/i18n';
import EcoPicture from 'eco-design/base/eco-picture';
import {useEffect, useState} from 'react';
import css from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('aboutus.B');

    const [enter, setEnter] = useState(false);
    const items = [
        {
            text: t('item1_text'),
            suffix: ' M+',
            arr: [1, 2, 3, 4, 5],
        },
        {
            text: t('item2_text'),
            suffix: '+',
            arr: [20, 60, 90, 120, 140],
        },
        {
            text: t('item3_text'),
            suffix: '',
            arr: [200, 400, 800, 1000, 1129],
        },
        {
            text: t('item4_text'),
            suffix: '+',
            arr: [10, 20, 40, 50, 60],
        },
    ];

    const list = [t('list1'), t('list2'), t('list3')];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scenes: any[] = [];
            ['items']?.map((cls: string) => {
                scenes?.push(
                    AniContainer.create({
                        triggerElement: `.${css.section} .${cls}`,
                        triggerHook: 1,
                        offset: 160,
                        duration: '100%',
                        onEnter: () => setEnter(true),
                        onLeave: () => setEnter(false),
                    }),
                );
            });

            return () => scenes?.forEach((scene: any) => scene && scene?.destroy());
        }
    }, []);

    return (
        <section id="about-us-B" className={`about-us-B ${css.section} GtmModuleData-section`} data-section-id="About-Us-B">
            <div className="box-container">
                <div className="img">
                    <EcoPicture
                        className="picture"
                        fetchPriority="high"
                        loading="eager"
                        jpg={[
                            'https://websiteoss.ecoflow.com/figma-uploads/1767864590779-276srw-compressed-Frame%202094654947.jpg',
                            'https://websiteoss.ecoflow.com/figma-uploads/1767864568381-dzj9bw-compressed-Frame%202094654649.jpg',
                        ]}
                        alt={t('title')}
                    />
                </div>
                <div className="info-container">
                    <div className="info">
                        <div className="title">{t('title')}</div>
                        <div className="desc">{t('desc')}</div>
                        <ul className="items">
                            {items?.map((item: any, i: number) => (
                                <li className="item" key={i}>
                                    <div className={`item-title ${enter ? 'enter' : 'leave'}`}>
                                        <ul className="item-nums" style={{ '--n': item.arr?.length } as React.CSSProperties}>
                                            {item.arr?.map((n: number | string, j: number) => (
                                                <li className="item-num" key={`${i}-${j}`}>
                                                    {n}
                                                </li>
                                            ))}
                                        </ul>
                                        <span className="item-suffix">{item.suffix}</span>
                                    </div>
                                    <p className="item-text">{item.text}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="right">
                        <div className="map-img">
                            <EcoPicture
                                className="picture"
                                fetchPriority="high"
                                loading="eager"
                                jpg={[
                                    'https://websiteoss.ecoflow.com/figma-uploads/1767866187193-94kxsu-compressed-Frame%20693.png',
                                    'https://websiteoss.ecoflow.com/figma-uploads/1767866240932-52wb30-compressed-Frame%202094654997.png',
                                ]}
                            />
                        </div>
                        <div className="list">
                            {new Array(3).fill(0).map((_: any, k: number) => (
                                <span className={`circle c${k + 1}`} key={k}>
                                    <span className="inner"></span>
                                    <span className="inner2"></span>
                                    <span className="inner3"></span>
                                    <span className="text">{list[k]}</span>
                                </span>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
